/** Pendant zu `Services/API/ApiUserService.cs`. */

import type { ChinaAppSysGroup, ChinaAppSysUser } from '@/types/entities';

import {
  buildAppPath,
  createCrudApi,
  requestOrFallback,
  requestSucceeded,
  type CrudApi,
} from '../apiBase';
import { apiClient } from '../httpClient';

const ENDPOINT = 'users';

export const userApi: CrudApi<ChinaAppSysUser> & {
  getGroups(id: number): Promise<ChinaAppSysGroup[]>;
  addGroup(id: number, groupId: number): Promise<boolean>;
  removeGroup(id: number, groupId: number): Promise<boolean>;
} = {
  ...createCrudApi<ChinaAppSysUser>(ENDPOINT),

  getGroups: (id) =>
    requestOrFallback(
      () => apiClient.get<ChinaAppSysGroup[]>(`${buildAppPath(ENDPOINT)}/${id}/groups`),
      [],
    ),

  // Der Altclient sendet hier bewusst keinen Rumpf.
  addGroup: (id, groupId) =>
    requestSucceeded(() =>
      apiClient.raw('POST', `${buildAppPath(ENDPOINT)}/${id}/groups/add/${groupId}`),
    ),

  removeGroup: (id, groupId) =>
    requestSucceeded(() =>
      apiClient.raw('DELETE', `${buildAppPath(ENDPOINT)}/${id}/groups/remove/${groupId}`),
    ),
};
